import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewChild, AfterViewInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { ClientNotesService } from 'src/app/services/apiclient/clientnotes/clientnotes.service';
import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { ClientRefillsService } from 'src/app/services/apiclient/clientrefills/clientrefills.service';
import { TableReservationClientService } from 'src/app/services/apiclient/table-reservation/table-reservation.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ClientCreditsService } from 'src/app/services/apiclient/clientcredits/clientcredits.service';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-filter-date-from-to',
  templateUrl: './filter-date-from-to.component.html',
  styleUrls: ['./filter-date-from-to.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class FilterDateFromToComponent implements OnInit {

  @Input() type: string|any;
  @Input() merchant: any;



  @Output() setLoaderEvent = new EventEmitter<boolean>();
  @Output() setDataEvent = new EventEmitter<any>();
  //scroll
  @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport|any;

  today: moment.Moment = moment();
  from: moment.Moment = moment().subtract(7, 'd');
  to:any


  inputDisabled: boolean = false;

  preFilledPeriods: any[] = [
    {
      name: this.translate.instant('filterDateComponent.custom'),
      colored: true
    },
    {
      name: this.translate.instant('filterDateComponent.today'),
      from: moment(),
      to: moment()
    },
    {
      name: this.translate.instant('filterDateComponent.yesterday'),
      from: moment().subtract(1, 'd'),
      to: moment().subtract(1, 'd')
    },
    {
      name: this.translate.instant('filterDateComponent.week'),
      from: moment().startOf('week'),
      to: moment()
    },
    {
      name: this.translate.instant('filterDateComponent.lastweek'),
      from: moment().subtract(7, 'd'),
      to: moment()
    },
    {
      name: this.translate.instant('filterDateComponent.lastMonth'),
      from: moment().subtract(30, 'd'),
      to: moment()
    },
    {
      name: this.translate.instant('filterDateComponent.year'),
      from: moment().startOf('year'),
      to: moment()
    },


  ];

valueCredit = {name: this.translate.instant('filterDateComponent.all'),
  from: moment().year(1900).month(1).date(1),
  to: moment()
}

  preFilledPeriod: any = this.preFilledPeriods[5];

  constructor(
    public media: MediaObserver,
    private noteApi: ClientNotesService,
    private refillsApi: ClientRefillsService,
    private orderApi: ClientOrdersService,
    private reservationApi: TableReservationClientService,
    private ClientCreditsService: ClientCreditsService,
    public translate: TranslateService

  ) {
    this.to = moment();
  }

  ngOnInit() {

    if (this.type=='credits') {
      this.preFilledPeriods.push(this.valueCredit);
      this.preFilledPeriod = this.preFilledPeriods[7];
    }
  }

  onPeriodChange(period: any) {

    this.viewPort.scrollToIndex(0);
    this.preFilledPeriod = period;
    this.from = period.from;
    this.to = period.to;

    if (this.from) {
      this.getDataFromPeriods();
    }
  }

  onDateFromChange() {
    this.preFilledPeriod = this.preFilledPeriods[0];
    if (this.from > this.to) {
      this.to = null;
     
    }
  }

  onDateToChange() {
    this.preFilledPeriod = this.preFilledPeriods[0];
  }

  getDataFromPeriods() {
    this.setLoaderData(true);
    this.setData([]);

   
    this.getCurrentObservableData(this.from.format('YYYY-MM-DD'), this.to.format('YYYY-MM-DD')).subscribe(data => {
      this.setData(data);
      this.setLoaderData(false);
    })
  }

  getCurrentObservableData(dateFrom: string, dateTo: string): Observable<any> {
    const merchantId:any = (this.merchant) ? parseInt(this.merchant.id_user) : null;
    return (this.type === 'orders')
      ? this.orderApi.getOrders(dateFrom, dateTo)
      : (this.type === 'notes')
        ? this.noteApi.getNotes(dateFrom, dateTo, merchantId)
        : (this.type === 'refills')
          ? this.refillsApi.getRefills(merchantId, dateFrom, dateTo)
          : (this.type === 'bookings')
            ? this.reservationApi.getBookings(dateFrom, dateTo)
            : (this.type === 'credits') ? this.ClientCreditsService.getCreditsLetter(dateFrom, dateTo, merchantId) : new Observable;
  }

  setLoaderData(flag: boolean) {
    this.inputDisabled = flag;
    this.setLoaderEvent.emit(flag);
  }

  setData(data: any) {
    this.setDataEvent.emit(data);
  }

}
